import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import bgimage from '../../../../images/raw_material/rice.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; 

const Raw_Material_Edit = ({ show, onClose, rawmaterialId, rawmaterialData }) => {
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  // const [file, setFile] = useState(null); // selected file
  const [imagePreview, setImagePreview] = useState(null); // to show either file or image_url

  const [rawMaterialCatOptions, setRawMaterialCatOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [groupedVendorOptions, setGroupedVendorOptions] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null); 
  // const [minimumUnit, setMinimumUnit] = useState(null);
  // const [maximumUnit, setMaximumUnit] = useState(null);
  const [purchaseUnit, setPurchaseUnit] = useState(null);
   
  const [selectedVendors, setSelectedVendors] = useState([]);

  const [rawMaterialName, setRawMaterialName] = useState('');
  const [brandName, setBrandName] = useState('');
  const [quantity, setQuantity] = useState('');
  const [expiryPeriod, setExpiryPeriod] = useState('');
  const [baseCost, setBaseCost] = useState('');
  const [minStock, setMinStock] = useState('');
  const [maxStock, setMaxStock] = useState('');
  const [purchaseQuantity, setPurchaseQuantity] = useState('');
  const [description, setDescription] = useState('');
  const [autoPurchase, setAutoPurchase] = useState(true);

  const [file, setFile] = useState(null);
  const imageInputRef = useRef(null);

  const [Checked, checkIsChecked] = useState(true);
  const [errors, setErrors] = useState({});


  // Fetch data for dropdowns
  useEffect(() => {
    axios.get(`${baseURL}/list/active`)
      .then(res => {
        const options = res.data.map(item => ({
          value: item.sno,
          label: item.rawmaterialcategory_name
        }));
        setRawMaterialCatOptions(options);
      });

    axios.get(`${baseURL}/manageunit/list/active`)
      .then(res => {
        const units = res.data.data.map(unit => ({
          value: unit.sno,
          label: unit.unitslug_name
        }));
        setUnitOptions(units);
      });

    axios.get(`${baseURL}/vendor-categories-with-vendors`)
      .then(res => {
        const vendors = res.data.data.map(cat => ({
          label: cat.category_name,
          options: cat.vendors.map(v => ({
            value: v.vendor_id,
            label: v.vendor_businessname
          }))
        }));
        setGroupedVendorOptions(vendors);
      });
  }, [baseURL]);

useEffect(() => {
    if (rawmaterialData && unitOptions.length > 0 && rawMaterialCatOptions.length > 0 && groupedVendorOptions.length > 0) {
      setRawMaterialName(rawmaterialData.rawmaterial_name || '');
      setBrandName(rawmaterialData.brand_name || '');
      setQuantity(rawmaterialData.rawmaterial_quantity || '');
      setExpiryPeriod(rawmaterialData.expiry_period || '');
      setBaseCost(rawmaterialData.base_cost || '');
      setMinStock(rawmaterialData.minimum_stock_level || '');
      setMaxStock(rawmaterialData.maximum_stock_level || '');
      setDescription(rawmaterialData.description || '');
      setAutoPurchase(rawmaterialData.auto_purchase === 0);
      checkIsChecked(rawmaterialData.auto_purchase === 0);
      setImagePreview(rawmaterialData.image_url || null); // ← ADD THIS
      setPurchaseQuantity(rawmaterialData.purchase_quantity || '');

      // Find category option by value
      setSelectedOption(
        rawMaterialCatOptions.find(opt => opt.value === rawmaterialData.rawmaterial_category) || null
      );

      // Find rawmaterial_unit by value (ID)
      setSelectedUnit(
        unitOptions.find(opt => opt.value === rawmaterialData.rawmaterial_unit) || null
      );

       

      // purchase_unit is by ID, match by value
      setPurchaseUnit(
        unitOptions.find(opt => opt.value === rawmaterialData.purchase_unit) || null
      );

      // Parse vendor JSON if available and match selected vendors
     if (rawmaterialData.vendor && Array.isArray(rawmaterialData.vendor)) {
  const vendorIds = rawmaterialData.vendor.map(v => v.sno); // extract vendor IDs
  const matchedVendors = [];
  groupedVendorOptions.forEach(group => {
    group.options.forEach(v => {
      if (vendorIds.includes(v.value)) {
        matchedVendors.push(v);
      }
    });
  });
  setSelectedVendors(matchedVendors);
      } else {
        setSelectedVendors([]);
      }

          // Set readonly fields
    setRawMaterialWastage(rawmaterialData.raw_material_wastage || '');
    setYieldValue(rawmaterialData.yield || '');

    }
  }, [rawmaterialData, unitOptions, rawMaterialCatOptions, groupedVendorOptions]);



const handleCheckboxChange = () => {
  const updated = !autoPurchase;
  setAutoPurchase(updated);
  checkIsChecked(updated);
};
 

  const fileHandler = (e) => {
  const selected = e.target.files[0];
  const validTypes = ['image/jpeg', 'image/png'];
  const maxSize = 50 * 1024;

  if (selected) {
    if (!validTypes.includes(selected.type)) {
      setErrors(prev => ({ ...prev, image: 'Only .jpg and .png formats are allowed.' }));
      return;
    } else if (selected.size > maxSize) {
      setErrors(prev => ({ ...prev, image: 'Image size must be 50KB or less.' }));
      return;
    } else {
      setErrors(prev => ({ ...prev, image: null }));
    }

    setFile(selected);
    setImagePreview(URL.createObjectURL(selected)); // ← set preview from file
  }
};


  const RemoveImage = () => {
    setFile(null);
    if (imageInputRef.current) imageInputRef.current.value = '';
  };

const validate = () => {
  let validationErrors = {};

  if (!selectedOption) {
    validationErrors.selectedOption = 'Please select a Raw Material Category.';
  }

  if (!rawMaterialName || rawMaterialName.toString().trim() === '') {
    validationErrors.rawMaterialName = 'Please enter Raw Material Name.';
  }

  if (!quantity || quantity.toString().trim() === '') {
    validationErrors.quantity = 'Please enter Quantity.';
  } else if (isNaN(quantity) || Number(quantity) < 0) {
    validationErrors.quantity = 'Quantity must be a non-negative number.';
  }

  if (!selectedUnit) {
    validationErrors.selectedUnit = 'Please select Units.';
  }

  if (!expiryPeriod || expiryPeriod.toString().trim() === '') {
    validationErrors.expiryPeriod = 'Please enter Expiry Period.';
  }

  if (!baseCost || baseCost.toString().trim() === '') {
    validationErrors.baseCost = 'Please enter Base Cost.';
  } else if (isNaN(baseCost) || Number(baseCost) < 0) {
    validationErrors.baseCost = 'Base Cost cannot be negative.';
  }

  if (!minStock || minStock.toString().trim() === '') {
    validationErrors.minStock = 'Please enter Minimum Stock Level.';
  } else if (isNaN(minStock) || Number(minStock) < 0) {
    validationErrors.minStock = 'Minimum Stock Level cannot be negative.';
  }

if (packedChecked && (!packedGST || !packedGST.value)) {
  validationErrors.packedGST = 'Please select GST for Packed item.';
}

if (unpackedChecked && (!unpackedGST || !unpackedGST.value)) {
  validationErrors.unpackedGST = 'Please select GST for Unpacked item.';
}


  if (!isNaN(minStock) && !isNaN(maxStock) && Number(minStock) > Number(maxStock)) {
    validationErrors.maxStock = 'Maximum Stock Level must be greater than or equal to Minimum Stock Level.';
  }
 
  if (!maxStock || maxStock.toString().trim() === '') {
    validationErrors.maxStock = 'Please enter Maximum Stock Level.';
  } else if (isNaN(maxStock) || Number(maxStock) < 0) {
    validationErrors.maxStock = 'Maximum Stock Level cannot be negative.';
  }
 

  if (file) {
  const validTypes = ['image/jpeg', 'image/png'];
  const maxSize = 50 * 1024; // 50 KB

  if (!validTypes.includes(file.type)) {
    validationErrors.image = 'Only .jpg and .png formats are allowed.';
  } else if (file.size > maxSize) {
    validationErrors.image = 'Image size must be 50KB or less.';
  }
}


  setErrors(validationErrors);

  return Object.keys(validationErrors).length === 0; // true if no errors
};


const handleSubmit = async () => {
  if (!validate()) return; // stop if validation fails

  const formData = new FormData();
  formData.append("rawmaterial_name", rawMaterialName);
  formData.append("rawmaterial_category", selectedOption?.value);
  formData.append("brand_name", brandName);
  formData.append("rawmaterial_quantity", quantity);
  formData.append("rawmaterial_unit", selectedUnit?.value);
  formData.append("expiry_period", expiryPeriod);
  formData.append("minimum_stock_level", minStock);
  // formData.append("minimum_unit", minimumUnit?.value);
  formData.append("maximum_stock_level", maxStock);
  // formData.append("maximum_unit", maximumUnit?.value);
  formData.append("base_cost", baseCost);
  formData.append("description", description);
  formData.append("auto_purchase", autoPurchase ? 0 : 1); // 0 = checked

  if (!autoPurchase) {
    formData.append("purchase_quantity", purchaseQuantity);
    formData.append("purchase_unit", purchaseUnit?.value);
  }

  if (packedChecked && packedGST?.value) {
  formData.append("packed_gst", packedGST.value);
  }

  if (unpackedChecked && unpackedGST?.value) {
    formData.append("unpacked_gst", unpackedGST.value);
  }
  formData.append('updated_by', user_id);

  // selectedVendors.forEach(v => formData.append("vendor[]", v.value));

  if (file) formData.append("rawmaterial_image", file);

  try {
    await axios.post(`${baseURL}/raw-materials/${rawmaterialId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    onClose();
    // window.location.reload();
  } catch (err) {
    console.error("Submit Error:", err?.response?.data || err.message);
  }
};

  const customStyles = {
    groupHeading: (provided) => ({
      ...provided,
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#333', 
    }),
  };

   
    const [showAddVendor, setShowAddVendor] = useState(false); 
    // const handleAddVendor = () => {
    //         setShowAddVendor(true);
    //     };

    const [categories, setCategories] = useState([]);
    const [businessTypes, setBusinessTypes] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedBusinessType, setSelectedBusinessType] = useState(null);
    const [selectedSettlementType, setSelectedSettlementType] = useState(null);
    const [selectedSelectType, setSelectedSelectType] = useState(null); // corresponds to your 'select_type'
      
    const [settlementTypeOption, setSettlementTypeOption] = useState([ 
    { value: 0, label: 'Weeks' },
    { value: 1, label: 'Months' },
    { value: 2, label: 'Years' },
    ]);

 useEffect(() => {
        axios.get(`${baseURL}/vendorcategory/category/active`)
        .then(response => {
            const options = response.data.map(category => ({
            value: category.sno,
            label: category.vendorcategory_name,
            }));
            setCategories(options);
        })
        .catch(error => {
            console.error('Error fetching categories:', error); 
        });
    }, [baseURL]);

    // Fetch Business Types
    useEffect(() => {
        axios.get(`${baseURL}/businesstype/type/active`)
        .then(response => {
            const options = response.data.map(type => ({
            value: type.sno,
            label: type.businesstype_name,
            }));
            setBusinessTypes(options);
        })
        .catch(error => {
            console.error('Error fetching business types:', error);
        });
    }, [baseURL]);

    const [newVendor, setNewVendor] = useState({
        vendor_category: null,
        vendor_businessname: '',
        vendor_mobileno: '',
        vendor_emailid: '',
        business_type: null,
        settlement_type: '',
        select_type: null,
        address: '',
        person_name: '',
        person_mobileno: ''
    });

 
const validateVendorForm = () => {
    const newErrors = {};

    if (!newVendor.vendor_category) newErrors.selectedCategory = "This field is required";
    if (!newVendor.vendor_businessname.trim()) newErrors.vendor_businessname = "This field is required";
    if (!newVendor.vendor_mobileno.trim()) newErrors.vendor_mobileno = "This field is required";
    if (!newVendor.business_type) newErrors.selectedBusinessType = "This field is required";
    if (!newVendor.settlement_type) newErrors.settlementTypeInput = "This field is required";
    if (!newVendor.select_type) newErrors.select_type = "This field is required";
    if (!newVendor.person_name.trim()) newErrors.person_name = "This field is required";
    if (!newVendor.person_mobileno.trim()) newErrors.person_mobileno = "This field is required";
    if (!newVendor.address.trim()) newErrors.address = "This field is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
};

const handleAddVendor = async () => {
    if (!validateVendorForm()) {
        return;
    }

    try {
        const payload = {
            vendor_category: newVendor.vendor_category,
            vendor_businessname: newVendor.vendor_businessname,
            vendor_mobileno: newVendor.vendor_mobileno,
            vendor_emailid: newVendor.vendor_emailid,
            business_type: newVendor.business_type,
            settlement_type: parseInt(newVendor.settlement_type),
            select_type: newVendor.select_type,
            address: newVendor.address,
            person_name: newVendor.person_name,
            person_mobileno: newVendor.person_mobileno,
        };

        const response = await axios.post(`${baseURL}/rawmanagevendor`, payload);
        const createdVendor = response.data.vendor;

        const newVendorOption = {
            label: createdVendor.vendor_businessname,
            value: createdVendor.sno,
        };

        setSelectedVendors(prev => [...prev, newVendorOption]);

        setShowAddVendor(false);
        setNewVendor({
            vendor_category: null,
            vendor_businessname: '',
            vendor_mobileno: '',
            vendor_emailid: '',
            business_type: null,
            settlement_type: '',
            select_type: null,
            address: '',
            person_name: '',
            person_mobileno: ''
        });
        setErrors({});
    } catch (error) {
        console.error("Vendor creation error", error.response?.data || error);
    }
};

 
const [form, setForm] = useState({ product_type: '' });
const [packedChecked, setPackedChecked] = useState(false);
const [unpackedChecked, setUnpackedChecked] = useState(false);
const [packedGST, setPackedGST] = useState(null);
const [unpackedGST, setUnpackedGST] = useState(null);
const [packedOptions, setPackedOptions] = useState([]);
const [unpackedOptions, setUnpackedOptions] = useState([]); 

useEffect(() => {
  if (packedChecked) {
    axios.get(`${baseURL}/purchase-gst/active/list`, { params: { producttype: '0' } })
      .then(res => {
        const options = res.data.data.map(gst => ({
          value: gst.sno,
          label: `${gst.gst_value}%`
        }));
        setPackedOptions(options);

        // Auto-select GST from rawmaterialData if available
        if (rawmaterialData?.packed_gst) {
          const matched = options.find(opt => opt.value === rawmaterialData.packed_gst);
          if (matched) setPackedGST(matched);
        }
      })
      .catch(() => setPackedOptions([]));
  }
}, [packedChecked]);

useEffect(() => {
  if (unpackedChecked) {
    axios.get(`${baseURL}/purchase-gst/active/list`, { params: { producttype: '1' } })
      .then(res => {
        const options = res.data.data.map(gst => ({
          value: gst.sno,
          label: `${gst.gst_value}%`
        }));
        setUnpackedOptions(options);

        // Auto-select GST from rawmaterialData if available
        if (rawmaterialData?.unpacked_gst) {
          const matched = options.find(opt => opt.value === rawmaterialData.unpacked_gst);
          if (matched) setUnpackedGST(matched);
        }
      })
      .catch(() => setUnpackedOptions([]));
  }
}, [unpackedChecked]);

// Trigger packed/unpacked state from rawmaterialData
 
useEffect(() => {
  if (rawmaterialData) {
    if (rawmaterialData.packed_gst) {
      setPackedChecked(true);
    }
    if (rawmaterialData.unpacked_gst) {
      setUnpackedChecked(true);
    }
  }
}, [rawmaterialData]);

const [rawMaterialWastage, setRawMaterialWastage] = useState('');
const [yieldValue, setYieldValue] = useState('');


    return (
        <Modal show={show} size="xl"> 
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Raw Material</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-4 mb-4">
                          <label className="text-black font-w500 fs-7">Raw Material Category<span className="required">*</span></label>
                          
                            <Select
                            placeholder="Select Raw Material Category"
                            value={selectedOption}
                            onChange={setSelectedOption}
                            options={rawMaterialCatOptions}
                            styles={customStyles}
                          />
                            {errors.selectedOption && <div className="text-danger fs-7 mt-1">{errors.selectedOption}</div>}
                      </div>
                     
                      <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">
                            Raw Material<span className="required">*</span>
                        </label>
                        

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Raw Material Name"
                          value={rawMaterialName}
                          maxLength={30}
                          onChange={(e) => {
                              const input = e.target.value;
                              const onlyLettersAndSpaces = input.replace(/[^a-zA-Z\s]/g, '');
                              const formatted = onlyLettersAndSpaces
                                  .split(' ')
                                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                  .join(' ');
                              setRawMaterialName(formatted);
                          }}
                      />


                        {errors.rawMaterialName && (
                            <div className="text-danger fs-7 mt-1">{errors.rawMaterialName}</div>
                        )}
                      </div>

                      <div className="col-lg-4 mb-4">
                          <label className="text-black font-w500 fs-7">Brand</label>
                          
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Brand Name"
                            value={brandName}
                            maxLength={30}
                            onChange={(e) => {
                                const input = e.target.value;
                                const onlyLettersAndSpaces = input.replace(/[^a-zA-Z\s]/g, '');
                                const formatted = onlyLettersAndSpaces
                                    .split(' ')
                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                    .join(' ');
                                setBrandName(formatted);
                            }}
                        />
 
                      </div>

                      <div className="col-lg-2 mb-4">
                        <label className="text-black font-w500 fs-7">Quantity<span className="required">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Quantity"
                            value={quantity}
                            maxLength={5}
                            onChange={(e) => {
                                const value = e.target.value;
                                // Allow only digits and limit to 5 characters
                                if (/^\d{0,5}$/.test(value)) {
                                    setQuantity(value);
                                }
                            }}
                        />
                        {errors.quantity && <div className="text-danger fs-7 mt-1">{errors.quantity}</div>}
                      </div>
 
                      <div className='col-lg-2 mb-4'>
                          <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                            <Select
                            placeholder="Select Units"
                            value={selectedUnit}
                            onChange={setSelectedUnit}
                            options={unitOptions}
                          />
                          {errors.selectedUnit && <div className="text-danger fs-7 mt-1">{errors.selectedUnit}</div>}
                      </div>
                  
                      <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">
                            Expiry Period (In Days)<span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Expiry Period"
                            value={expiryPeriod}
                            maxLength={5}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,5}$/.test(value)) {
                                    setExpiryPeriod(value);
                                }
                            }}
                        />
                        {errors.expiryPeriod && <div className="text-danger fs-7 mt-1">{errors.expiryPeriod}</div>}
                      </div>
 
                      <div className="col-lg-4 mb-2">
                        <div className="row mb-2">

                          {/* Packed */}
                          <div className="col-lg-6">
                            <div className="form-check custom-checkbox">
                              <input
                                type="checkbox"
                                className="form-check-input me-2"
                                id="packedCheck"
                                checked={packedChecked}
                                onChange={() => {
                                  const isChecked = !packedChecked;
                                  setPackedChecked(isChecked);
                                }}
                              />

                              <label className="text-black font-w500 fs-7" htmlFor="packedCheck">
                                Packed <span className="required">*</span>
                              </label>
                            </div>

                            {packedChecked && (
                              <div className="mt-2">
                                <Select
                                  placeholder="Select GST"
                                  value={packedGST}
                                  onChange={(option) => {
                                    setPackedGST(option);
                                    setErrors(prev => ({ ...prev, gst: '' }));
                                  }}
                                  options={packedOptions}
                                />
                                {errors.gst && form.product_type === 'packed' && (
                                  <span className="text-danger fs-7">{errors.gst}</span>
                                )}
                                {errors.packedGST && (
                              <span className="text-danger fs-7">{errors.packedGST}</span>
                            )}



                              </div>
                            )}
                          </div>

                          {/* Unpacked */}
                          <div className="col-lg-6">
                            <div className="form-check custom-checkbox">
                              <input
                                type="checkbox"
                                className="form-check-input me-2"
                                id="unpackedCheck"
                                checked={unpackedChecked}
                                onChange={() => {
                                  const isChecked = !unpackedChecked;
                                  setUnpackedChecked(isChecked);
                                }}
                              />
                              <label className="text-black font-w500 fs-7" htmlFor="unpackedCheck">
                                Unpacked <span className="required">*</span>
                              </label>
                            </div>

                            {unpackedChecked && (
                              <div className="mt-2">
                                <Select
                                  placeholder="Select GST"
                                  value={unpackedGST}
                                  onChange={(option) => {
                                    setUnpackedGST(option);
                                    setErrors(prev => ({ ...prev, gst: '' }));
                                  }}
                                  options={unpackedOptions}
                                />
                                {errors.gst && form.product_type === 'unpacked' && (
                                  <span className="text-danger fs-7">{errors.gst}</span>
                                )}
                                {errors.unpackedGST && (
                                <span className="text-danger fs-7">{errors.unpackedGST}</span>
                                )}
                              </div>
                            )}
                          </div>

                        </div>
                      </div>

                      <div className="col-lg-4 mb-4">
                          <label className="text-black font-w500 fs-7">
                              Base Cost<span className="required">*</span>
                          </label>
                          <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Base Cost"
                              value={baseCost}
                              maxLength={8} // allows something like 12345.67 (8 chars)
                              onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                                      setBaseCost(value);
                                  }
                              }}
                          />
                          {errors.baseCost && (
                              <div className="text-danger fs-7 mt-1">{errors.baseCost}</div>
                          )}
                      </div> 

                      <div className="col-lg-4 mb-4">
                          <label className="text-black font-w500 fs-7">
                              Min Stock Level<span className="required">*</span>
                          </label>
                          <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Minimum Stock Level"
                              value={minStock}
                              maxLength={5} 
                              onChange={(e) => {
                                  const val = e.target.value;
                                  setMinStock(val);

                                  // Validate min is less than max if max exists
                                  if (maxStock && parseFloat(val) >= parseFloat(maxStock)) {
                                      setErrors(prev => ({ ...prev, minStock: 'Min stock should be less than Max stock' }));
                                  } else {
                                      setErrors(prev => ({ ...prev, minStock: '' }));
                                  }
                              }}
                          />
                          {errors.minStock && <div className="text-danger fs-7 mt-1">{errors.minStock}</div>}
                      </div>

                      <div className="col-lg-4 mb-4">
                          <label className="text-black font-w500 fs-7">
                              Max Stock Level<span className="required">*</span>
                          </label>
                          <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Maximum Stock Level"
                              value={maxStock}
                              maxLength={5} 
                              onChange={(e) => {
                                  const val = e.target.value;
                                  setMaxStock(val);

                                  // Validate max is greater than min if min exists
                                  if (minStock && parseFloat(val) <= parseFloat(minStock)) {
                                      setErrors(prev => ({ ...prev, maxStock: 'Max stock should be greater than Min stock' }));
                                  } else {
                                      setErrors(prev => ({ ...prev, maxStock: '' }));
                                  }
                              }}
                          />
                          {errors.maxStock && <div className="text-danger fs-7 mt-1">{errors.maxStock}</div>}
                      </div>

                      <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">
                          Raw Material Wastage (in %)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={rawMaterialWastage}
                          readOnly
                        />
                      </div>

                      <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">
                          Yield (in %)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={yieldValue}
                          readOnly
                        />
                      </div>

                      <div className="col-lg-4 mb-4">
                          <div className="form-check custom-checkbox">
                              <input
                                  type="checkbox"
                                      checked={autoPurchase}
                                      onChange={handleCheckboxChange}
                                  className="form-check-input me-3" 
                                  required

                              />
                              <label className="text-black font-w500 fs-7" htmlFor="customCheckBox1">Auto Purchase</label>
                          </div>
                      </div>

                      <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Description</label>
                        <textarea
                            className="form-control h-auto"
                            name="comment"
                            placeholder="Description"
                            maxLength={100}
                            value={description}
                            onChange={(e) => {
                                const value = e.target.value;
                                const capitalized = value.charAt(0).toUpperCase() + value.slice(1);
                                setDescription(capitalized);
                            }}
                        />
                      </div>

                      <div className="col-lg-4 mb-4">
                            <label className="text-black font-w500 fs-7 d-block">Raw Material Image</label>
                             <span className='fs-8 text-gray-800'>Size: </span>
                            <span className='fs-8 text-danger'>15 * 15</span>
                            <span className='fs-8 text-gray-800 ms-2'>Format: </span>
                            <span className='fs-8 text-danger'>.png, .jpg</span>
                            <div className="avatar-upload d-flex align-items-center">
                                <div className="change position-relative">
                                    <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                                    
                                         <img
                                        id="saveImageFile"
                                        src={imagePreview || bgimage}
                                        alt="Raw Material"
                                        className="p-1 h-125px w-125px"
                                      />

                                    </div>
                                    <div className="change-btn">
                                        <input
                                            type="file"
                                            id="imageUpload"
                                            accept=".png, .jpg, .jpeg"
                                            style={{ display: 'none' }}
                                            ref={imageInputRef}
                                             onChange={fileHandler}
                                        />
                                        <div className="mt-2 d-flex justify-content-center">
                                            <Button
                                                className="btn-xs mb-2 me-2"
                                                variant="success"
                                                onClick={() => imageInputRef.current.click()}
                                            >
                                                <span className="">
                                                    <i className="fa fa-upload color-success fs-3" />
                                                </span>
                                            </Button>
                                            <Button
                                                className="btn-xs mb-2 me-2"
                                                variant="danger"
                                                onClick={RemoveImage}
                                            >
                                                <span className="">
                                                    <i className="fa fa-close color-danger fs-3" />
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                    {errors.image && (
                                      <span className="text-danger fs-8">{errors.image}</span>
                                    )}
                                </div>
                            </div>
                      </div>

                    </div> 
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4"> 
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Raw Material <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal >
    );
};

export default Raw_Material_Edit;
